import {useMemo} from 'react';
import {useSearchParams} from 'react-router-dom';
import {PLAYER_PRES_ID_QUERY, PLAYER_ROOM_ID_QUERY, PRESENTER_CODE_QUERY, ROOM_ADMIN_QUERY} from '../incase-domain/online';

interface PresentationParams {
    presentationId: string | null;
    roomId: string | null;
    isRoomAdmin: boolean;
    presenterCode: string | null;
    params: {[key: string]: string};
}

export const usePresentationParams = (): PresentationParams => {
    const [searchParams] = useSearchParams();

    const presentationParams = useMemo(() => {
        const paramsObject = Object.fromEntries(searchParams.entries());
        const presentationId = paramsObject[PLAYER_PRES_ID_QUERY] || null;
        const roomId = paramsObject[PLAYER_ROOM_ID_QUERY] || null;
        const isRoomAdmin = paramsObject[ROOM_ADMIN_QUERY] === 'true';
        const presenterCode = paramsObject[PRESENTER_CODE_QUERY] || null;

        /* eslint-disable @typescript-eslint/no-unused-vars */
        const {
            [PLAYER_PRES_ID_QUERY]: _,
            [PLAYER_ROOM_ID_QUERY]: __,
            [ROOM_ADMIN_QUERY]: ___,
            [PRESENTER_CODE_QUERY]: ____,
            ...params
        } = paramsObject;

        return {presentationId, roomId, isRoomAdmin, presenterCode, params};
    }, [searchParams]);

    return presentationParams;
};
